export default {
  welcome_back: 'Welcome back',
  access_your_account_by_choosing_your_country: 'Access your account by choosing your country',
  eu: 'EU',
  sweden: 'Sweden',
  denmark: 'Denmark',
  norway: 'Norway',
  finland: 'Finland',
  brazil: 'Brazil',
  dont_have_an_account: 'Don’t have an account?',
  need_help: 'Need help?',
  sign_up: 'Sign Up',
  contact_support: 'Contact support',
  register_your_account_by_choosing_your_country: 'Register your account by choosing your country',
  welcome_to: 'Welcome to',
  sign_in: 'Sign in',
  already_registered: 'Already registered?',
  quickbyte_global_description:
    'is one of the world’s first crypto currency exchanges that offers advanced ID verification and full KYC through official electronic ID solutions.',
  investment_disclaimer:
    'This shall not constitute investment advice, nor an invitation or recommendation to engage in any cryptocurrency exchange operations. Any investment in cryptocurrencies carries risks of total or partial capital loss and a risk of significant volatility. Past financial performance does not guarantee future performance. Only risk the capital you are willing to lose.',
  accept_terms: 'Yes, I accept the',
  back: 'Back',
  hello_use_your_bankid: 'Hello, use your BankID to create your account',
  bankid: 'BankID',
  code_brick: 'Code brick',
  sign_in_to_your_account: 'Sign in to your account',
  sign_up_to_account: 'Enter your email address and password to create your account',
  verify: 'Verify',
  verify_code: 'Verify code',
  resend_code: 'Resend code',
  enter_your_code: 'Enter the 6-digits code we sent to ',
  enter_your_code_placeholder: 'Enter your 6-digits code',
  set_password: 'Set password',
  password_placeholder: 'Enter your password',
  retype_password_placeholder: 'Confirm password',
  email_address: 'Email address',
  password: 'Password',
  register_fail_message: 'Failed to register user',
  provide_email_address: 'Provide your account email address',
  password_successfully_changed: 'Your password has been successfully changed',
  account_successfully_created: 'The account has been successfully created. Please log in.',
  create_account: 'Create account',
  next: 'Next',
  set_new_password: 'Set new password',
  password_must_contains: 'Your password must contain',
  password_options: {
    number: '1 number',
    uppercase_letter: '1 uppercase letter',
    lowercase_letter: '1 lowercase letter',
    special_character: '1 special character',
  },
  forgot_password: 'Forgot password?',
  multi_factor_authentication: 'Multi-Factor Authentication',
  enter_totp_code: 'Enter TOTP code',
  confirm_code: 'Confirm code',
  enable_multi_factor_authentication: 'Enable Two-Factor Authentication',
  disable_multi_factor_authentication: 'Disable Two-Factor Authentication',
  need_help_logging_in: 'Need help logging in?',
  electronic_id_solution_not_implemented: 'Electronic ID solution not yet implemented. Please login with email.',
  overview: 'Overview',
  buy: 'Buy',
  sell: 'Sell',
  transfer: 'Transfer',
  transactions: 'Transactions',
  settings: 'Settings',
  logout: 'Logout',
  total_wallet_value: 'Total wallet value',
  available_for_transfer: 'Available for transfer',
  available_to_sell: 'Available to sell',
  buy_bitcoin: 'Buy Bitcoin',
  bitcoin_value_over_time: 'Bitcoin value over time',
  bitcoin_balance: 'Bitcoin balance',
  total_value: 'Total value',
  quick_buy: 'Quick-buy',
  buy_with: 'Buy with',
  add_a_debit_card: 'Add a debit card',
  pay_by_card: 'Pay by card',
  pay_by_bank: 'Pay by bank',
  pay_with: 'Pay with',
  quickbyte_global_notice: 'This service is offered by',
  bank_statement: 'Your bank statement will read',
  payment_methods: 'Payment methods',
  back_to_payment_methods: 'Back to payment method selection',
  save_this_payment_method: 'Save this payment method for later use',
  terms_conditions: 'Terms & Conditions',
  cancel_purchase: 'Cancel purchase',
  previous: 'Previous',
  purchase_summary: 'Purchase summary',
  you_are_spending: 'You are spending',
  bitcoin_price: 'Bitcoin price',
  platform_fee: 'Platform Fee',
  you_will_receive: 'You will receive',
  payment: 'Payment',
  failed: 'failed',
  successful: 'successful',
  payment_error_message: 'An error has occurred. Please retry or contact our support.',
  retry_payment: 'Retry payment',
  payment_successful: 'Payment successful',
  thank_you_for_your_purchase: 'Thank you for your purchase',
  new_bitcoin_balance: 'New Bitcoin balance',
  download_transaction_receipt: 'Download transaction receipt',
  view_transaction_status: 'View Transaction status',
  buy_more_bitcoin: 'Buy more Bitcoin',
  bitcoins_stored_notice: 'By default, your Bitcoins will be stored in your',
  want_to_sell: 'I want to sell for',
  available: 'available',
  select_funds_destination: 'Select funds destination',
  add_a_bank_account: 'Add a bank account',
  max: 'Max',
  bank_account_details: 'Bank account details',
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  recipients_email: "Recipient's email",
  email_is_invalid: 'Email is invalid',
  iban: 'IBAN',
  bic: 'BIC',
  transaction_cannot_be_undone: 'Yes, I understand this transaction cannot be undone',
  verify_bank_account_ownership: 'Yes, I verify that I am the rightful owner of this bank account',
  accept_terms_conditions_quickbyte:
    'Yes, I accept the Terms and Conditions of Quickbyte Global OÜ (Org no. 14746140), Estonia.',
  sell_bitcoin: 'Sell Bitcoin',
  continue: 'Continue',
  cancel_sale: 'Cancel sale',
  worth_of_bitcoin: 'worth of Bitcoin',
  value_in_bitcoin: 'value in Bitcoin',
  add_your_account_details: 'Add your account details',
  selling_summary: 'Selling summary',
  you_are_selling: 'You are selling',
  you_sold: 'You sold',
  funds_destination: 'Funds Destination',
  name: 'Name',
  bank_account: 'Bank account',
  confirm_sale: 'Confirm sale',
  sell_failed: 'Sell failed',
  retry_sell: 'Retry sell',
  sell_successful: 'Sell successful',
  sell_amount_low: 'The amount is too low. Please try again',
  insufficient_balance: 'Insufficient balance',
  min_sell_amount_is: 'Minimum sell amount is',
  max_sell_amount_is: 'Maximum sell amount is',
  iban_error_message:
    'Field [iban] is not valid: IBAN must start with country code (2 characters) and check digits (2 digits)',
  thank_you_for_your_sale: 'Thank you for your sale',
  sell_more_bitcoin: 'Sell more Bitcoin',
  quick_transfer: 'Quick-transfer',
  wallet_destination: 'Wallet destination',
  enter_wallet_address: 'Enter wallet address',
  myself: 'Myself',
  someone_else: 'Someone else',
  transaction_confirmation_notice:
    'I confirm that this transaction does not constitute Payment for illegal products or services or a transfer to online casino or sports betting services in countries where this is prohibited.',
  confirm_transfer: 'Confirm transfer',
  transfer_summary: 'Transfer summary',
  you_have_transferred: 'You have transferred',
  you_are_transferring: 'You are transferring',
  value_in_eur: 'Value in EUR',
  network_fee: 'Network fee',
  total: 'Total',
  wallet: 'Wallet',
  wallet_owner: 'Wallet’s owner',
  transfer_bitcoin: 'Transfer Bitcoin',
  cancel_transfer: 'Cancel transfer',
  retry_transfer: 'Retry transfer',
  transfer_more_bitcoin: 'Transfer more Bitcoin',
  transactions_registered: 'Transactions registered',
  recent_transactions: 'Recent transactions',
  see_all_transactions: 'See all transactions',
  in_total: 'transactions in total',
  transaction_details: 'Transaction details',
  bought_for: 'Bought for',
  sold_for: 'Sold for',
  btc_price: 'BTC price',
  reference: 'Reference',
  payment_method: 'Payment method',
  value_of: 'Value of',
  date: 'Date',
  at: 'at',
  type: 'Type',
  value: 'Value',
  value_in_btc: 'Value in BTC',
  gains: 'Gains',
  details: 'Details',
  gains_loss: 'Gains/Loss',
  status: 'Status',
  manage: 'Manage',
  created: 'Created',
  processed: 'Processed',
  purchase: 'Purchase',
  my_profile: 'My profile',
  profile: 'Profile',
  contact_information: 'Contact information',
  address: 'Address',
  your_wallet_on: 'Your wallet on',
  share_internal_address: 'Share your internal',
  transfer_btc_to_users: 'You can transfer bitcoin to other dashboard users and they can transfer bitcoin to you.',
  full_name: 'Full name',
  birth_date: 'Birth date',
  phone: 'Phone',
  kyc_type: 'KYC type',
  nationality: 'Nationality',
  social_number: 'Social Security Number',
  your_address: 'Your address',
  address_line_1: 'Address line 1',
  address_line_2: 'Address line 2',
  postal_code: 'Postal code',
  city: 'City',
  country: 'Country',
  save: 'Save',
  cancel: 'Cancel',
  add_another_card: 'Add another card',
  add_another_bank: 'Add another bank account',
  read_more: 'Read more in',
  general_risk: 'General Risk Disclosure',
  and: 'and',
  privacy_policy: 'Privacy Policy',
  regarding_utilizing: 'regarding utilizing',
  services_and_processing: 'services and processing, storage and use of my personal data.',
  is_located_in: 'is located in',
  something_wrong: 'Something went wrong. Please try again later.',
  transfer_success_1: 'Thank you for your transfer',
  transfer_success_2:
    'Your transfer will go through compliance checks before being processed on the blockchain. Please allow up to 1 business days for a response.',
  general: 'General',
  questionnaire: 'Questionnaire',
  open_questionnaire: 'Open the PEP questionnaire',
  my_payment_methods: 'My payment methods',
  transactions_statements: 'Transactions statements',
  preferred_currency: 'Preferred currency',
  preferred_payment_method: 'Preferred payment method',
  registered_payment_methods: 'Registered payment methods',
  any_payment_methods: 'You dont have any saved payment methods.',
  show_less: 'Show less',
  show_more: 'Show more',
  select_date: 'Select date',
  from: 'From',
  to: 'To',
  download_csv: 'Download CSV',
  transactions_selected_period: 'No transactions for the selected period',
  transactions_error_download:
    'There was an error while downloading the transactions statement. Please try again. If the problem persists, please contact our support.',
  export_transactions: 'Export transactions into a CSV file from a selected time range.',
  limit_transactions: 'Transaction limit exceeded. Please try again later.',
  card: 'Card',
  vBTCTransferLimitError_too_low: 'The transfer amount is too low. Please try again with a different amount.',
  vBTCTransferLimitError_too_high: 'The transfer amount is too high. Please try again with a different amount.',
  vBTCTransferWalletError: 'An error occurred. Please try again.',
  vBTCTransferExceedBalanceError: 'The wallet balance is too low. Please top up and try again.',
  ranges: {
    '4h': '4h',
    '1d': '1d',
    '2d': '2d',
    '7d': '7d',
    '30d': '30d',
    '1w': '1w',
    '1m': '1m',
    '3m': '3m',
    '6m': '6m',
    '1y': '1y',
    all_time: 'All time',
  },
  transactionType: {
    Purchase: 'BTC purchased',
    Sell: 'BTC sold',
    Transfer: 'BTC sent',
    externalTransfer: 'BTC sent',
  },
  transactionStatus: {
    Created: 'Created',
    Processed: 'Processed',
    Error: 'Error',
    Timeout: 'Timeout',
  },
  countries: {
    EU: 'EU',
    Sweden: 'Sweden',
    Denmark: 'Denmark',
    Norway: 'Norway',
    Finland: 'Finland',
    Brazil: 'Brazil',
    Estonia: 'Estonia',
  },
  card_number_placeholder: 'Card Number',
  country_of_destination: 'Country of destination',
  session_management: 'Session Management',
  mask_tooltip_message:
    'Unmasking your CVV can expose sensitive information. Only do this in a private, secure environment. In public or shared spaces, keep your CVV masked to protect your financial information.',
  transfer_disclaimer:
    'This service is offered by Bfinance EOOD Dba. Blockforia, Operating License: BB-49 / 06.01.2023, Sofia City 1463, Sofia Region, Sofia Municipality, District Triaditza, 15Zdrave Str, fl.1. Your bank statement will read Blockforia.',
  invalid_phone_number: 'Invalid phone number',
  choose_country: 'Choose country',
  questionnaire_submit_failed: 'Submitting failed',
  questionnaire_submit_error: 'Please try again or contact support',
  receive_funds: 'Receive funds',
  advanced: 'Advanced',
  amount: 'Amount',
  currency: 'Currency',
  callback_url: 'Callback URL',
  portfolio_value: 'Portfolio value',
  equivalent_to: 'Equivalent to',
  bank_transfer_tooltip: {
    title: 'Pay simply, done quickly',
    subtitle: 'Secure payment, direct from your bank account',
    item_1: 'No card details needed',
    item_2: 'Connects to your banking app',
    item_3: 'Approve using bank-level security',
  },
  payment_pending_title: 'Payment is being processed',
  payment_pending_message:
    'Your payment is currently pending. We’ll update the status as soon as we receive confirmation.',
};
